import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { ShieldAlert, ArrowLeftCircle } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/stores/auth";

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { user, impersonation, stopImpersonation } = useAuth();

  if (!impersonation || !user) return null;

  const handleStop = () => {
    stopImpersonation();
    queryClient.invalidateQueries();
    toast.info(`Voltou pra ${impersonation.adminUser.email}`);
    navigate("/users", { replace: true });
  };

  return (
    <div
      role="alert"
      className="
        sticky top-16 z-banner mx-auto
        bg-warning-100/95 text-warning-700 border-b border-warning-200
        backdrop-blur-md
      "
    >
      <div className="flex items-center justify-between gap-4 px-4 sm:px-6 py-2.5 max-w-7xl mx-auto">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="h-5 w-5 flex-shrink-0" aria-hidden />
          <p className="text-sm font-medium truncate">
            Modo impersonation —{" "}
            <span className="font-semibold">{impersonation.adminUser.email}</span>
            {" navegando como "}
            <span className="font-semibold">{user.email}</span>{" "}
            ({user.role})
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleStop}
          className="border-warning-500 text-warning-700 hover:bg-warning-200 flex-shrink-0"
        >
          <ArrowLeftCircle className="h-4 w-4" aria-hidden />
          <span className="hidden sm:inline">Voltar pra mim</span>
        </Button>
      </div>
    </div>
  );
}
